// ----
// JS for centering Ad based on the width of the AdvertisementText
// ----
var App = App || {};

App.CenterAdBlock = (function () {

    return {
        Init: init
    };

    // Initializes the CenterAdBlock js
    function init($adBlockDiv, $advertisementTextElement) {
        if (shouldAdblockBeCentered($adBlockDiv, $advertisementTextElement)) {
            $adBlockDiv.css('margin-left', $advertisementTextElement.outerWidth(true));
        }
    }

    //Checks if the Ad should be centered (if the Ad is in the header or footer, and if it has the desktop view property "writing-mode = vertical-rl;")
    function shouldAdblockBeCentered($adBlockDiv, $advertisementTextElement) {
        return ($adBlockDiv.parent().hasClass('js-adBlockHeader') || $adBlockDiv.parent().hasClass('js-adBlockFooter') || $adBlockDiv.parent().hasClass('js-adBlockStickyFooter'))
            && $advertisementTextElement.css('writing-mode') === 'vertical-rl';
    }

})();